import { ReactComponent as polyline } from '../../../../icons/polyline.svg';
import './uploadGeometryModal.scss';
import React, { useContext, useEffect, useRef, useState } from "react";
import Modal from "../../../../components/modalWindow/modal";
import ButtonField from '../../../../components/buttonField/buttonField';
import { classNameBtn } from '../../../../components/shared/button/types/buttonProps';
import { ButtonFieldProps } from '../../../../components/buttonField/types/buttonFieldProps';
import { stylizationVerticalAlign } from '../../../../components/shared/stylization';
import { UploadGeometryModalPropsProps, UploadGeometryTypes } from './types/uploadGeometryModalProps';
import Dropzone from '../../../../components/dropzone/dropzone';
import ProgressBarField from '../../../../components/progressBarField/progressBarField';
import { UploadProcessStatus } from '../../../../components/progressBarField/progressBarInfo/types/progressBarInfoProps';
import { ProgressBarFieldProps } from '../../../../components/progressBarField/types/progressBarFieldProps';
import { cancelChunkUpload, startChunkUpload } from '../../../../services/chunkUploadService/chunkUploadService';
import { apiContext } from '../../../../contexts/apiContext';
import UploadGeometrySummary from './uploadGeometrySummary';
import './uploadGeometryModal.scss';
import InfoModal from '../../../../components/modalWindow/infoModal';
import Spinner from '../../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../../components/spinner/types/spinnerProps';
import { addUpdateWaitingRoomGeometry, checkReferenceLayersAvailability, newGeometry, updateGeometryDefault } from '../../../../services/geometryService/geometryService';
import { AddGeometryProps, CheckReferenceLayersAvailabilityProps, NewUpdateGeometryProps } from '../../../../services/geometryService/types/geometryServiceProps';
import { cancelUploadGeometry, checkUploadGeometry } from '../../../../services/checkUploadGeometryService/checkUploadGeometryService';
import { LoadingParams } from '../../../../services/checkUploadGeometryService/props/checkUploadGeometryServiceProps';
import { notifyError } from '../../../../components/snackbar/snackbar';
import PermissionsContext from '../../../../contexts/permissionsContext';
import ViewContext from '../../../../contexts/viewContext';

const UploadGeometryModal = (props: UploadGeometryModalPropsProps) => {
    const SMALL_HEIGHT = '486px';
    const BIG_HEIGHT = '576px';
    const [activeBtn, setActiveBtn] = useState<UploadGeometryTypes>(UploadGeometryTypes.New);
    const [progress, setProgress] = useState<boolean>(false);
    const [uploading, setUploading] = useState<boolean>(false);
    const [summary, setSummary] = useState<boolean>(false);
    const [summaryObject, setSummaryObject] = useState<any>(null);
    const [cancelDisabled, setCancelDisabled] = useState<boolean>(true);
    const [uploadedFileName, setUploadedFileName] = useState<string>('');
    const [errorLoading, setErrorLoading] = useState<string>('');
    const [currentUploadStatus, setCurrentUploadStatus] = useState<string>(UploadProcessStatus.Uploading)
    const [uploadPercent, setUploadPercent] = useState<number>(0);
    const [layerAvailabilityChecked, setLayerAvailabilityChecked] = useState<boolean>(false);
    const [noLayersInfo, setNoLayersInfo] = useState<boolean>(false);
    const [noLayersInfoText, setNoLayersInfoText] = useState<string>("");
    const { apiUrl, apiVersion } = useContext(apiContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const { setViewData } = useContext(ViewContext);

    let jobId = useRef<string>('');
    let intervalId: NodeJS.Timer;

    useEffect(() => {
        if (props.isTriggeredByAdminDecision) {
            setActiveBtn(UploadGeometryTypes.UpdateWaitingRoom);
            setViewData(undefined);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {

        return clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        var checkReferenceLayersAvailabilityProps: CheckReferenceLayersAvailabilityProps = {
            apiBase: apiUrl + apiVersion
        }
        checkReferenceLayersAvailability(checkReferenceLayersAvailabilityProps)
        .then((res: any) => {
            console.log('ref res ', res);
            if(res === ""){
                setTimeout(() => {
                    setLayerAvailabilityChecked(true);
                    setNoLayersInfoText("");
                }, 300);
            }
            else{
                setTimeout(() => {
                    setNoLayersInfo(true);
                    setNoLayersInfoText(res);
                }, 300)
            }
        })
        .catch((err: any) => {
            console.log('ref err ', err);
            
            setTimeout(() => {
                setNoLayersInfo(true);
            }, 300)

        })

    }, [apiUrl, apiVersion]);

    const getBtnProps = (actionType: UploadGeometryTypes, title: any, disable: boolean): ButtonFieldProps => {
        let className = classNameBtn.BigSecondary + " body-txt-XL";
        if (actionType === activeBtn) {
            className += " BigSecondaryActive";
        }
        return {
            BtnProps: {
                onClick: () => { upload(actionType) },
                style: {
                    width: '260px',
                    height: '86px'
                },
                disabled: (progress && uploading) || disable,
                className: className
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
        };
    }

    const getActionBtnProps = (title: string, btnClass: string, disabled: boolean, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                disabled: disabled,
                className: `${classNameBtn.Btn} ${btnClass} body-txt-medium`
            },
            placeHolder: title
        };
    }

    const getProgressBarFieldProps = (currentPercentage: number, uploadProcessStatus: string, fileName: string): ProgressBarFieldProps => {
        return {
            progressBarInfoProps: {
                currentPercentage: currentPercentage,
                fileName: fileName,
                uploadProcessStatus: uploadProcessStatus
            },
            progressBarProps: {
                currentPercentage: currentPercentage
            }
        }
    }

    const cancelDefault = () => {
        setProgress(false);
        setCancelDisabled(true);
        setUploading(false);
    }

    const cancel = () => {
        if (currentUploadStatus === UploadProcessStatus.Uploading) {
            cancelChunkUpload();
            cancelDefault();
            setSummary(true);
            jobId.current = '';
            setErrorLoading('');
        }
        else {
            cancelUploadGeometry(apiUrl + apiVersion, jobId.current).then((response: any) => {
                clearInterval(intervalId);
                cancelDefault();
                setSummary(true);
                jobId.current = '';
                setErrorLoading('Ładowanie geometrii zostało przerwane');
            }).catch((error: any) => {
                console.log("error cancel", error);
                clearInterval(intervalId);
                cancelDefault();
                setSummary(true);
                jobId.current = '';
                setErrorLoading('Ładowanie geometrii zostało przerwane');
            });
        }
    }

    const finish = () => {
        if (uploading) {
            setUploading(false);
            setSummary(true);
        } else {
            close();
        }
    }

    const handleCloseSummary = () => {
        setSummary(false);
        setProgress(false);
        jobId.current = '';
    }

    const close = () => {
        props.onClose();
    }

    const upload = (actionType: UploadGeometryTypes) => {
        setActiveBtn(actionType);
        setProgress(false);
    }

    const handleConfirm = (files: File[]) => {
        setProgress(true);
        setUploading(true);
        setCancelDisabled(false);
        setUploadedFileName(files[0].name);
        if (uploadPercent !== 0) setUploadPercent(0);
        if (currentUploadStatus !== UploadProcessStatus.Uploading) setCurrentUploadStatus(UploadProcessStatus.Uploading);
        startChunkUpload(files[0], apiUrl + apiVersion,
            (res: number) => {
                // TODO limit chunk total percent
                setUploadPercent(res);
            },
            (res: any) => {
                if (!res.isCanceled) {
                    // TODO limit chunk total percent
                    setUploadPercent(30);
                    //setCurrentUploadStatus(UploadProcessStatus.Finish);
                    //setCancelDisabled(true);
                    jobId.current = res.guid;

                    if (activeBtn === UploadGeometryTypes.New) newGeometryUpload(res.guid);
                    if (activeBtn === UploadGeometryTypes.UpdateDefaultDb) updateGeometryDefaultUpload(res.guid);
                    if (activeBtn === UploadGeometryTypes.Waiting || activeBtn === UploadGeometryTypes.UpdateWaitingRoom) addGeometryUpload(res.guid);
                }
            },
            (err: string) => { console.log(err) });
    }

    const addGeometryUpload = (fileGuid: string) => {
        setSummaryObject(null);
        setErrorLoading('');
        let addGeometryProps: AddGeometryProps = {
            uploadedFileGuid: fileGuid,
            apiBase: apiUrl + apiVersion,
            isAdd: activeBtn === UploadGeometryTypes.Waiting
        }
        setCurrentUploadStatus(UploadProcessStatus.UnpackingZipFile);
        setUploadPercent(35);
        checkProgress(fileGuid);
        addUpdateWaitingRoomGeometry(addGeometryProps)
            .then((response: any) => {
                clearInterval(intervalId);
                console.log("res addGeometryUpload: ", response);
                setUploadPercent(100);
                setCurrentUploadStatus(UploadProcessStatus.Finish);
                setCancelDisabled(true);
                setUploading(false);
                setSummaryObject(response);
                setSummary(true);
            })
            .catch((error: any) => {
                clearInterval(intervalId);
                if (error.message !== "Network Error") {
                    console.log("err addGeometryUpload: ", error);
                    if (error.response !== undefined && error.response !== null && error.response.data != null) {
                        setErrorLoading(error.response.data);
                    }
                }
                else {
                    notifyError({ message: "Błąd połączenia" });
                }
                cancelDefault();
                setSummary(true);
            });
    }

    const updateGeometryDefaultUpload = (fileGuid: string) => {
        setSummaryObject(null);
        setErrorLoading('');
        let newUpdateGeometryProps: NewUpdateGeometryProps = {
            uploadedFileGuid: fileGuid,
            apiBase: apiUrl + apiVersion
        }
        setCurrentUploadStatus(UploadProcessStatus.UnpackingZipFile);
        setUploadPercent(35);
        checkProgress(fileGuid);
        updateGeometryDefault(newUpdateGeometryProps)
            .then((response: any) => {
                clearInterval(intervalId);
                console.log("res updateGeometryUpload: ", response);
                setUploadPercent(100);
                setCurrentUploadStatus(UploadProcessStatus.Finish);
                setCancelDisabled(true);
                setUploading(false);
                setSummaryObject(response);
                setSummary(true);
            })
            .catch((error: any) => {
                clearInterval(intervalId);
                if (error.message !== "Network Error") {
                    console.log("err addGeometryUpload: ", error);
                    if (error.response !== undefined && error.response !== null && error.response.data != null) {
                        setErrorLoading(error.response.data);
                    }
                }
                else {
                    notifyError({ message: "Błąd połączenia" });
                }
                cancelDefault();
                setSummary(true);
            });
    }

    const newGeometryUpload = (fileGuid: string) => {
        setSummaryObject(null);
        setErrorLoading('');
        let newUpdateGeometryProps: NewUpdateGeometryProps = {
            uploadedFileGuid: fileGuid,
            apiBase: apiUrl + apiVersion
        }
        setCurrentUploadStatus(UploadProcessStatus.UnpackingZipFile);
        setUploadPercent(35);
        checkProgress(fileGuid);
        newGeometry(newUpdateGeometryProps)
            .then((response: any) => {
                clearInterval(intervalId);
                console.log("res newGeometryUpload: ", response);
                setUploadPercent(100);
                setCurrentUploadStatus(UploadProcessStatus.Finish);
                setCancelDisabled(true);
                setUploading(false);
                setSummaryObject(response);
                setSummary(true);
            })
            .catch((error: any) => {
                clearInterval(intervalId);
                if (error.message !== "Network Error") {
                    console.log("err addGeometryUpload: ", error);
                    if (error.response !== undefined && error.response !== null && error.response.data != null) {
                        setErrorLoading(error.response.data);
                    }
                }
                else {
                    notifyError({ message: "Błąd połączenia" });
                }
                cancelDefault();
                setSummary(true);
            });
    }
    const checkProgress = (fileGuid: string) => {
        intervalId = setInterval(() => {
            var loadingParams: LoadingParams = {
                guid: fileGuid,
                progressCallback: () => {

                },
                finishedCallback: () => {

                },
                notFinishedCallback: () => {

                }
            }

            checkUploadGeometry(loadingParams, apiUrl + apiVersion)?.then((res: any) => {
                if (currentUploadStatus !== UploadProcessStatus.Finish) {
                    if (uploadPercent !== 100) {
                        if (res === "GPValidation") {
                            setCurrentUploadStatus(UploadProcessStatus.Validation);
                            setUploadPercent(40);
                        }
                        // if (res === "GPLoadData") {
                        //     setCurrentUploadStatus(UploadProcessStatus.CreatingObjects);
                        //     setUploadPercent(50);
                        // }

                        if ((res as string).includes("GPLoading")) {
                            var loading = (res as string).split(",");
                            if(loading != null && loading.length > 2){
                                setCurrentUploadStatus(loading[1]);
                                setUploadPercent(Number(loading[2]));
                            }
                        }

                        // if (res === "GPMap") {
                        //     setCurrentUploadStatus(UploadProcessStatus.MapCreation);
                        //     setUploadPercent(90);
                        // }
                    }
                    if (res === "Finished") {
                        setCurrentUploadStatus(UploadProcessStatus.Finish);
                        setUploadPercent(100);
                        setUploading(false);
                        setCancelDisabled(true);
                    }
                    console.log("check response", res);
                }
            }).catch((error: any) => {
                console.log("error", error);
            });
        }, 2000);
        return intervalId;
    }

    const getHeight = () => {
        return progress ? BIG_HEIGHT : SMALL_HEIGHT;
    }

    const actionBtns = [
        <ButtonField key={1} {...getActionBtnProps("Anuluj wgrywanie", classNameBtn.LargeSecondary, cancelDisabled, cancel)} />,
        <ButtonField key={2} {...getActionBtnProps("Zakończ wgrywanie", classNameBtn.Large, !cancelDisabled || !uploading, finish)} />
    ]

    const closeModal = () => {
        if (!progress || (progress && !uploading)) {
            props.onClose();
        }
    }

    const acceptedFiles = [
        "application/zip",
        "application/x-zip-compressed"
    ]

    return (<Modal
        title={"Wgraj geometrię"}
        titleIcon={polyline}
        width={'1088px'}
        height={getHeight()}
        actionBtns={actionBtns}
        onClose={closeModal}>
        <div className="cardGeomBtns">
            <ButtonField {...getBtnProps(UploadGeometryTypes.New, "Nowe obiekty", !functionsPermissions.processN.active)}></ButtonField>
            <ButtonField {...getBtnProps(UploadGeometryTypes.UpdateDefaultDb, <>Aktualizacja <br></br>(baza główna)</>, !functionsPermissions.processA.active)}></ButtonField>
            <ButtonField {...getBtnProps(UploadGeometryTypes.UpdateWaitingRoom, "Aktualizacja (poczekalnia)", !functionsPermissions.processA.active)}></ButtonField>
            <ButtonField {...getBtnProps(UploadGeometryTypes.Waiting, "Dogranie geometrii", !functionsPermissions.addGeometry.active)}></ButtonField>
        </div>
        {layerAvailabilityChecked && <Dropzone key={activeBtn} disabled={progress} multiple={false} acceptedFiles={acceptedFiles} onConfirm={handleConfirm} acceptedFilesForSnackbar='.zip' dropzoneText='Przeciągnij i upuść plik, aby dodać go do formularza.'/>}
        {!layerAvailabilityChecked && <div className='dropzoneSpinner'> <Spinner spinnerClass={ClassNameSpinner.Big} /> </div>}
        {noLayersInfo && <InfoModal width={"660px"} height={"auto"}
            cancelTitle={"Zamknij"}
            onCancel={() => {setNoLayersInfo(false); setNoLayersInfoText(""); setLayerAvailabilityChecked(true);}}
            information={noLayersInfoText}
        />}
        {progress && <ProgressBarField {...getProgressBarFieldProps(uploadPercent, currentUploadStatus, uploadedFileName)} />}
        {summary && <UploadGeometrySummary error={errorLoading} jobId={jobId.current} onClose={handleCloseSummary} summary={summaryObject} />}
    </Modal>);
};

export default UploadGeometryModal;